/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Keyboardshortcuts1Inputs */

const zh_common_keyboardshortcuts1 = /** @type {(inputs: Common_Keyboardshortcuts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快捷键`)
};

const en_common_keyboardshortcuts1 = /** @type {(inputs: Common_Keyboardshortcuts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyboard shortcuts`)
};

const es_common_keyboardshortcuts1 = /** @type {(inputs: Common_Keyboardshortcuts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atajos de teclado`)
};

/**
* | output |
* | --- |
* | "Keyboard shortcuts" |
*
* @param {Common_Keyboardshortcuts1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const common_keyboardshortcuts1 = /** @type {((inputs?: Common_Keyboardshortcuts1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Keyboardshortcuts1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_common_keyboardshortcuts1(inputs)
	if (locale === "en") return en_common_keyboardshortcuts1(inputs)
	return es_common_keyboardshortcuts1(inputs)
});
export { common_keyboardshortcuts1 as "common_keyboardShortcuts" }